<template>
  <!--  首页搜索框-->
  <div class="order-search">
    <div class="order-search_input" :class="{borderBlue:borderBlue}">
      <div class="textarea_box">
        <div class="textarea_num colorBB">
          <ul>
            <li
              v-for="(item, index) in inputNum"
              :key="index"
              :style="{height:25 * Math.max(Math.ceil(inputNum[index].length/150), 1) + 'px' }">
              {{index + 1 + '.'}}
            </li>
          </ul>
        </div>
        <div class="textarea_error">
          <div
            class="textarea_error_line"
            v-for="(item, index) in inputNum"
            :key="index"
            :style="{height:25 * Math.max(Math.ceil(inputNum[index].length/150), 1) + 'px' }">
          </div>
        </div>
        <textarea
          @click.stop="ExpandQueryFn"
          @focus="borderBlueFn()"
          @blur="borderBlueFnout()"
          v-model="textareaValue"
          :placeholder="$t('page.please_enter_tracking_limit')"
          id="bb"
          class="color33"
          @keydown.enter="enterkey"
          @scroll="handleScroll">
        </textarea>
        <div class="textarea_delect colorBB">
          <ul>
            <li
              v-for="(item, index) in inputNum"
              :key="index"
              :style="{height:25 * Math.max(Math.ceil(inputNum[index].length/150), 1) + 'px' }">
              <i class="el-icon-error colorBB delect_icon pointer" v-show="textareaValue" @click="delectInput(index)"></i>
            </li>
          </ul>
        </div>
      </div>
      <el-collapse-transition>
        <div class="order-search_input-button_box" v-show="buttonShow && ExpandQuery">
          <div class="order-search_input-button colorF size12">
            <el-button size="small" @click="delectAll">{{$t('page.delete_all')}}</el-button>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="marTop15" type="flex" justify="center">
      <el-row v-if="!externalCall" class="searchnow marRight20 pointer colorF btnHover transition3ms" @click.native="search"><i class="iconfont iconyunyingshang colorF size18 marRight10"></i> {{$t('page.components_a')}}</el-row>
      <a v-else class="searchnow searchnow_a marRight20 transition3ms colorF btnHover" :href="`https://trackingyee.com/trackingResults?nums=${nums}&carrierCode=${carrierCode}`" target="_blank">
        <i class="iconfont iconyunyingshang colorF size18 marRight10"></i> {{$t('page.components_a')}}
      </a>
      <el-row class="carriers pointer color66 btnwbHover transition3ms" @click.native="shippersOpen(true)" type="flex" align="middle">
        <img class="shipperimg" :src="shipperLogoPictureUrl" alt="" v-if="shipperLogoPictureUrl">
        <i class="iconfont iconwuliu1 size18 marRight10" v-if="!shipperLogoPictureUrl"></i>
        {{zhName?zhName:$t('page.home_e')}}
        <el-tooltip v-if="shipperLogoPictureUrl" :content="$t('page.delete_carrier')" class="deleterCarier">
          <i
            class=" el-icon-error colorBB"
            @click.stop="shippersEmpty">
          </i>
        </el-tooltip>
      </el-row>
    </el-row>
    <transition name="el-fade-in">
      <shippers-window
        @changeShipper="changeShipper"
        @quickBack="quickBack"
        @close="shippersOpen"
        v-if="shippersShow">
      </shippers-window>
    </transition>

  </div>
</template>

<script>
  // import shippersWindow from '../../components/new/shippersWindow.vue'
  import LocalStorage from '@/common/localStorage.js'
  import shippersWindow from './shippersWindow.vue'

  export default {
    props: {
      shipperData: {},
      externalCall: {
        type:Boolean,
        default:false
      },
      ExpandQuery: {
        type:Boolean,
        default:false
      },
    },
    data() {
      return {
        borderBlue: false,//边框颜色
        ExpandQuery_: false,// 展开运单查询框
        placeholder: this.$t('page.one_line_enter_limit'),
        inputNum: [''],
        warningMsg: [
          this.$t('page.more_than_limit_number_tip'),
          this.$t('page.please_enter_tracking_no')
        ],
        shippersShow: false,
        // noLogo: require('../image/noImage.png'),
        // shippersImage: require('../image/car.png'),
        shippersName: this.$t('page.carrier'),
        carrierCode: '',
        buttonShow: false,
        textareaValue: '',
        shipperLogoPictureUrl: '',
        timer: '',
        zhName: '',
        nums:[],
      }
    },
    // computed: {
    //   inputNum () {
    //     return this.textareaValue.split('\n')
    //   }
    // },
    mounted() {
      if (localStorage.getItem('searchList')) {
        JSON.parse(localStorage.getItem('searchList')).items.forEach(t => {
          this.textareaValue += t.trackingNo + '\n'
        })
        this.$once('hook:beforeDestroy', () => {
          localStorage.removeItem('searchList')
        })
      }
    },
    components: {
      shippersWindow
    },
    watch: {
      shipperData(n) {
        console.log(n)
        if (n.code) {
          this.shippersName = n.name
          this.carrierCode = n.code
        }
      },
      inputNum(n) {
        let vm = this
        if (n.length > 1 || n[0]) {
          this.buttonShow = true
          vm.nums = []
          vm.inputNum.map(function (t, i) {
            vm.nums.push(t)
          })
        } else {
          this.buttonShow = false
          this.nums = []
        }
      },
      textareaValue(n) {
        let num = n.split('\n')
        this.inputNum = []
        num.forEach((t, i) => {
          this.$set(this.inputNum, i, t)//解决inputNum没有及时更新的bug
        })
        if (num.length > 40) {
          // bb.setAttribute('readonly','readonly')
          this.textareaValue = ''
          this.textareaValue = this.inputNum.slice(0, 40).join('\n')
          // this.$message({
          //   type: 'warning',
          //   message: '查询订单超出限制，最多只能查询40条',
          //   showClose: true
          // })
        } else {
          // bb.removeAttribute('readonly')
        }
        // this.inputNum = n.split('\n')
        this.inputNum = this.inputNum.map(t => {//去除每个单号末尾的空格
          return t.trim()
        })
        let error = document.getElementsByClassName("textarea_error_line")
        for (let i = 0; i < error.length; i++) {
          error[i].classList.remove('textarea_error_show')
        }
      }
    },
    methods: {
      shippersEmpty() {
        this.carrierCode = ''
        this.shipperLogoPictureUrl = ''
        this.zhName = ''
      },
      enterkey(e) {
        let vm = this
        let bb = document.getElementById('bb')
        setTimeout(() => {
          bb.scrollTop = bb.scrollHeight//保持滚动条最底部，不然样式错乱
        }, 100)
        if (this.inputNum.length > 39) {
          vm.utils.delay(function () {
            vm.$message({
              type: 'warning',
              message: '查询订单超出限制，最多只能查询40条',
              showClose: true
            })
          }, 1000)
          e.preventDefault()
        }
      },
      ExpandQueryFn() {
        this.ExpandQuery_ = true
        this.$emit('ExpandQueryFn',this.ExpandQuery_)
      },
      borderBlueFnout() {
        this.borderBlue = false
      },
      borderBlueFn() {
        this.borderBlue = true
      },
      shippersOpen(value) {
        this.shippersShow = value
      },
      changeShipper(data) {
        this.shippersName = data.name
        this.carrierCode = data.code
        this.shipperLogoPictureUrl = data.logoPictureUrl
        this.zhName = data.zhName
      },
      handleScroll() {
        let num = document.querySelector('.textarea_num')
        let delect = document.querySelector('.textarea_delect')
        let error = document.querySelector('.textarea_error')
        let bb = document.querySelector('#bb')
        error.scrollTop = bb.scrollTop
        num.scrollTop = bb.scrollTop
        delect.scrollTop = bb.scrollTop
      },
      pasteValue(index, e) {
        // let reg = /\r\n/
        let beg = /\n/
        let val = e.clipboardData.getData('text/plain')
        // console.log(val)
        // console.log(reg.test(val))
        // console.log(beg.test(val))
        if (beg.test(val)) {
          let a = val.split('\n')
          if (a.length + this.inputNum.length > 40) {
            this.$message({
              type: 'warning',
              message: this.$t('page.more_than_limit_number_tip2'),
              showClose: true
            })
          }
          a[0] = this.inputNum[index] + a[0]
          let n = a.length
          this.inputNum.splice(index, 1, ...a)
          // console.log(a)
          this.$nextTick(() => {
            this.$refs.input[index + n - 1].focus()
          })
        } else {
          this.inputNum[index] += val
          this.inputNum.splice(index + 1, 0, '')
          this.$nextTick(() => {
            this.$refs.input[index + 1].focus()
          })
        }
      },
      passwordEnter(event, index, value) {
        if (event.keyCode === 13 && index < 39 && this.inputNum.length < 40) {
          // console.log(index)
          this.inputNum.splice(index + 1, 0, '')
          this.$nextTick(() => {
            this.$refs.input[index + 1].focus()
          })
        } else if (event.keyCode === 8 && !value && index !== 0) {
          this.inputNum.splice(index, 1)
          this.$nextTick(() => {
            this.$refs.input[index - 1].focus()
          })
        } else if (index >= 39) {
          this.$message({
            message: this.warningMsg[0],
            type: 'warning',
            showClose: true
          })
        }
      },
      keyUp(index) {
        if (index !== 0) {
          this.$refs.input[index - 1].focus()
        }
      },
      keyDown(index) {
        if (index !== this.inputNum.length - 1) {
          this.$refs.input[index + 1].focus()
        }
      },
      // delectInput (index) {
      //   if (this.inputNum.length > 1) {
      //     this.inputNum.splice(index, 1)
      //   } else if (this.inputNum.length === 1) {
      //     this.inputNum = ['']
      //   }
      // },
      delectInput(index) {
        if (this.inputNum.length > 1) {
          let c = this.textareaValue.split('\n')
          c.splice(index, 1)
          this.textareaValue = c.join('\n')
        } else if (this.inputNum.length === 1) {
          this.textareaValue = ''
        }
      },
      shippers() {
        // this.$nextTick(() => {
        //   this.shippersShow = true
        // })
        this.$emit('changeState', 'shipper')
      },
      shippersClose() {
        let shippersData = LocalStorage.get('shippers-choose')
        if (shippersData.code) {
          this.shippersName = shippersData.name
          this.shippersImage = shippersData.logoPictureUrl ? shippersData.logoPictureUrl : this.noLogo
          this.carrierCode = shippersData.code
          LocalStorage.set('shippers-choose', {})
        }
        this.shippersShow = false
      },
      search() {
        let vm = this
        let an = this.screeningOrder()
        if (an) {
          return false
        }
        setTimeout(function () {
          if (vm.inputNum.length === 1 && !vm.inputNum[0]) {
            vm.$message({
              message: vm.warningMsg[1],
              type: 'warning',
              showClose: true
            })
            return false
          }
          if (vm.inputNum.length > 40) {
            vm.$message({
              type: 'warning',
              message: vm.$t('page.more_than_limit_number_tip2'),
              showClose: true
            })
            return false
          }
          let list = {
            items: []
          }
          vm.inputNum.map(function (t, i) {
            list.items.push({
              trackingNo: t,
              carrierCode: vm.carrierCode
            })
          })
          LocalStorage.set('searchList', JSON.stringify(list))
          this.list = JSON.stringify(list)
          vm.$emit('quickSearch', list)
          vm.$router.push({name: `trackingResults`, params: {aotoSroll: true}})
        }, 200)
      },
      delectAll() {
        this.textareaValue = ''
        this.inputNum = []
      },
      screeningOrder(screening) {
        let orderList = []
        let vm = this
        let re = /^[0-9a-zA-Z]+$/
        let error = document.getElementsByClassName("textarea_error_line")
        for (let i = 0; i < error.length; i++) {
          error[i].classList.remove('textarea_error_show')
        }
        let okArr = []
        this.inputNum.forEach(t => {//去除数组中空字符串
          if (t !== '') {
            okArr.push(t)
          }
        })
        this.inputNum = okArr
        this.textareaValue = this.inputNum.join('\n')//数组转字符串并加\n换行符
        this.inputNum.map(function (item, index) {
          if (!re.test(item) || item.length > 50 || item.length < 3) {
            console.log(item)
            error[index].classList.add("textarea_error_show")
          }
        })
        let an = this.inputNum.some(function (t) {
          return (!re.test(t) || t.length > 50 || t.length < 3)
        }) || this.textareaValue === ''
        console.log('an', an)
        if (an) {
          vm.$message({
            message: this.$t('page.some_tracking_no_wrong'),
            type: 'warning',
            showClose: true
          })
        } else if (screening) {
          // vm.$message({
          //   message: '已自动筛选单号',
          //   type: 'success',
          //   showClose: true
          // })
        }
        return an
      },
      quickBack() {
        this.shippersEmpty()
        this.shippersOpen(false)
      }
    }
  }
</script>

<style scoped>
  .order-shipper-close {
    position: absolute;
    top: 0;
    right: 0;
  }

  .order-search {
    width: 100%;
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*margin-bottom: 13px;*/
  }

  .order-search_input {
    width: 100%;
    height: 300px;
    /*border: 1px solid #289EFC;*/
    border: 1px solid #ddd;
    border-radius: 12px;
    background: #fff;
    /* overflow: auto; */
    position: relative;
  }

  .borderBlue {
    border: 1px solid #289EFC !important;
  }

  .order-search_input-margin {
    height: 205px;
    margin-bottom: 50px;
    margin-top: 20px;
    margin-left: 60px;
    margin-right: 40px;
    /* overflow: auto; */
    position: relative;
  }

  .order-search_input-box {
    width: 100%;
    min-width: 600px;
    height: 25px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
  }

  .order-search_input-box_num {
    height: 25px;
    width: 25px;
    line-height: 25px;
    text-align: right
  }

  .order-search_input-box_input {
    height: 25px;
    width: 85%;
    line-height: 25px;
  }

  .order-search_input-box_delect {
    width: 17px;
    height: 17px;
    margin: 4px;
    text-align: left;
    cursor: pointer;
    /* background: url('../image/delect.png') no-repeat; */
    background-size: 100%;
  }

  .order-search_input-box_delect:hover {
    /* background: url('../image/delect2.png') no-repeat; */
    background-size: 100%;
  }

  .order-search_input-button_box {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 17px;
  }

  .order-search_input-button {
    display: flex;
    width: 577px;
    justify-content: center;
  }

  .order-search_input-button_button {
    width: 212px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    border-radius: 14px;
  }

  /* .order-search_input-button_button:hover {
    background-color: #EAEDF1;
  } */
  .order-search_button {
    position: relative;
  }

  .order-search_button img {
    width: 38px;
  }

  .order-search_button-shippers {
    width: 125px;
    height: 140px;
    border: 1px #dddddd solid;
    border-radius: 5px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    text-align: center;
    background-color: #ffffff;
    display: flex;
    align-content: center;
  }

  .order-search_button-shippers:hover {
    background-color: #f7f7f7
  }

  .order-search_button-shippers div {
    margin: auto;
    padding-top: 10px;
  }

  .order-search_button-shippers-logo {
    width: 104px;
  }

  .order-search_button-shippers-logo img {
    width: 100%;
  }

  .order-search_button-search {
    width: 125px;
    height: 140px;
    border: 1px #dddddd solid;
    border-radius: 5px;
    position: absolute;
    right: 0;
    bottom: 0;
    cursor: pointer;
    text-align: center;
    display: flex;
    align-content: center;
  }

  .order-search_button-search:hover {
    background-color: rgb(59, 140, 252);
  }

  .order-search_button-search div {
    margin: auto;
    padding-top: 10px;
  }

  input::-webkit-input-placeholder {
    color: #bbbbbb;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #bbbbbb;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #bbbbbb;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bbbbbb;
  }

  .textarea_box {
    width: 100%;
    position: relative;
    margin-bottom: 50px;
  }

  .textarea_num {
    position: absolute;
    top: 20px;
    left: 2%;
    height: 225px;
    line-height: 25px;
    overflow: hidden;
    text-align: right;
    z-index: 9;
  }

  .textarea_delect {
    position: absolute;
    top: 20px;
    right: 2%;
    height: 225px;
    line-height: 25px;
    overflow: hidden;
    z-index: 9
  }

  .textarea_error {
    position: absolute;
    top: 20px;
    left: 1%;
    height: 225px;
    overflow: hidden;
    width: 98%;
    z-index: 1;
  }

  .textarea_error_line {
    border-radius: 3px;
    box-sizing: border-box;
  }

  .textarea_error_show {
    border: 1px solid #FD483F;
  }

  .delect_icon:hover {
    color: #333;
  }

  #bb {
    width: 90%;
    padding: 0 5%;
    line-height: 25px;
    height: 225px;
    margin-top: 20px;
    z-index: 9;
    position: relative;
  }

  textarea {
    resize: none;
    font-family: 'Microsoft YaHei';
    word-break: break-all;
    -webkit-appearance: none;
    border: none;
    background: none;
    /*清除苹果input默认样式*/
    border-radius: 0;
    outline: none;
    z-index: 9;
  }

  .searchnow {
    width: 170px;
    height: 40px;
    background: rgba(40, 158, 252, 1);
    opacity: 1;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .carriers {
    position: relative;
    width: 180px;
    height: 40px;
    background: white;
    opacity: 1;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DCDFE6;
  }

  .shipperimg {
    margin-right: 5px;
    width: 34px;
    height: 34px;
    /*border: 1px solid #efefef;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/orderSearch.vue